var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('HeaderLogo'),_c('HeaderBurger'),_c('HeaderMobileMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }